import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import CustomLink from '../../utils/CustomLink';
import ContentWrapper from '../ContentWrapper';
import SectionContainer from '../SectionContainer';

export default function LinkedImageSection({ data }) {
  return (
    <SectionContainer backgroundColor="white">
      <ContentWrapper>
        <div className="linked-image-grid">
          {data.linkedImages.map((link) => (
            <CustomLink key={link.id} to={link.url}>
              {link.image ? (
                <GatsbyImage
                  alt={link.altText}
                  image={link.image.gatsbyImageData}
                />
              ) : (
                link.altText
              )}
            </CustomLink>
          ))}
        </div>
      </ContentWrapper>
    </SectionContainer>
  );
}
